<!--
 * @Description:
 * @Author: wangjiawei
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-08-25 10:15:53
 * @LastEditors: linfangxing 2948276710@qq.com
 * @LastEditTime: 2023-03-09 13:57:18
 -->
<template>
  <div class="leader-page">
    <div class="header-title">
      <header>网上老年大学领导</header>
      <!-- <div>（以区划为序）</div> -->
    </div>
    <div class="square">
      <ul class="leader-footer">
        <li
          class="leader-wrapper"
          v-for="(user, index) in leaderList"
          :key="index"
        >
          <img :src="user.image || avator" />
          <p class="name">{{ user.name }}</p>
          <div class="job" v-for="(job, jobInd) in user.jobs" :key="jobInd">
            {{ job }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leaderList: [
        {
          name: "李春华",
          image: require("@/assets/wslndx/lichunhua.png"),
          jobs: [
            "网上老年大学校长、",
            "现任中国老年大学协会副秘书长、",
            "中国老年大学协会办公室主任、",
            "中国老年大学艺术团团长",
          ],
        },
        {
          name: "吴光权",
          image: require("@/assets/wslndx/wuguangquan.jpg"),
          jobs: [
            // "网上老年大学常务副校长、",
            // "中国老年大学协会官网总编辑、",
            // "中国老年大学协会官网副主任",
            "网上老年大学执行校长",
          ],
        },
        {
          name: "张志海",
          image: require("@/assets/wslndx/zhangzhihai.jpg"),
          jobs: ["中国老年大学协会", "官网办公室副主任"],
        },
        // {
        //   name: "罗婷",
        //   jobs: ["网上老年大学教研处主任"],
        // },
        // {
        //   name: "苏振其",
        //   jobs: ["网上老年大学招生管理办公室主任"],
        // },
        // {
        //   name: "戴习文",
        //   jobs: ["网上老年大学科研处主任"],
        // },
        // {
        //   name: "邝政飞",
        //   image: require("@/assets/wslndx/kuangzhengfei.png"),
        //   jobs: ["网上老年大学宣传调研处主任"],
        // },
      ],
      avator: require("@/assets/about/niming.png"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import url("minireset.css");
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
.leader-page {
  padding: 60px 90px 60px 90px;
}
.header-title {
  text-align: center;
  margin-bottom: 60px;
  & > header {
    @include font-style("PingFangSC-Medium", 36px, rgba(58, 58, 58, 1), 500);
    line-height: 50px;
    letter-spacing: 1px;
  }
  & > div {
    margin-top: 10px;
    @include font-style("PingFangSC-Regular", 20px, rgba(58, 58, 58, 1), 400);
    line-height: 28px;
  }
}
.container {
  margin-top: 20px;
  & > div {
    display: inline-flex;
    justify-content: space-between;
    min-width: 56px;
    margin-right: 13px;
    margin-bottom: 14px;
    @include font-style("PingFangSC-Regular", 18px, rgba(58, 58, 58, 1), 400);
    line-height: 25px;
  }
  // & > div:nth-child(11n) {
  //   margin-right: 0;
  // }
}
.leader-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 26px;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
  // grid-template-rows: 310px 310px 310px;
  // grid-gap: 20px 20px;
  .leader-wrapper {
    width: 240px;
    // min-height: 290px;
    background: #f8f8f8;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 17px;
    margin-bottom: 20px;
    padding: 20px 18px;
    box-sizing: border-box;
    img {
      margin-top: 10px;
      width: 110px;
      height: 110px;
      overflow: hidden;
      border-radius: 50%;
    }
    .name {
      height: 25px;
      margin-top: 20px;
      margin-bottom: 5px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3a3a3a;
      line-height: 25px;
    }
    .job {
      min-width: 210px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #7a7a7a;
    }
  }
  .leader-wrapper:nth-child(3n) {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wslndx/WslndxLeader.vue